import React from 'react';
const NoPlanWidget = ({ label }) => {
  return (
    <div className={label === 'deductables' ? 'deductables' : 'out-of-pocket'}>
      <h3>
        This Plan has{' '}
        {label === 'deductables' ? (
          <span>No Deductible</span>
        ) : (
          <span>
            No <br />
            Out-of-pocket
          </span>
        )}
      </h3>
    </div>
  );
};
export default NoPlanWidget;
